<script lang="ts">
  import { browser } from '$app/environment';
  import { page } from '$app/stores';
  import { filterQuery } from '$components/QueryFilterInput.svelte';
  import Sidebar from '$components/Sidebar.svelte';
  import { audio } from '$components/toasts/RaceAlertToast.svelte';
  import { isFiltering, raceFilters } from '$utils/filters';
  import { selectedRaceId } from '$utils/navigation';
  import { filterRace } from '$utils/race';
  import { fade } from 'svelte/transition';

  $: ({ user, races } = $page.data);

  $: filteredRaces =
    $races?.data?.races.filter((r) => {
      if (filterRace($filterQuery, $raceFilters, r, $isFiltering)) {
        return true;
      }
      return false;
    }) ?? [];

  // initialise the audio as an empty sound to allow autoplay on safari
  const initNotifications = () => {
    if (browser) {
      try {
        const audioDisabled =
          user?.data?.user?.alertConfig?.alertSound === false;
        if (audio && !audioDisabled) {
          audio.autoplay = true;
          audio.src =
            'data:audio/mpeg;base64,SUQzBAAAAAABEVRYWFgAAAAtAAADY29tbWVudABCaWdTb3VuZEJhbmsuY29tIC8gTGFTb25vdGhlcXVlLm9yZwBURU5DAAAAHQAAA1N3aXRjaCBQbHVzIMKpIE5DSCBTb2Z0d2FyZQBUSVQyAAAABgAAAzIyMzUAVFNTRQAAAA8AAANMYXZmNTcuODMuMTAwAAAAAAAAAAAAAAD/80DEAAAAA0gAAAAATEFNRTMuMTAwVVVVVVVVVVVVVUxBTUUzLjEwMFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zQsRbAAADSAAAAABVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zQMSkAAADSAAAAABVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV';
        }
        //   check if we can get the notification permission (i.e. on iOS)
        if (window.Notification && Notification.permission !== 'granted') {
          Notification.requestPermission();
        }
      } catch (error) {
        // this could be for a variety of reasons, but we don't want to stop the app from loading
        console.error('Error initialising notifications', error);
      }
    }
  };

  $: {
    // track the user's session
    if (browser && $selectedRaceId) {
      fetch('/api/session', {
        method: 'POST',
        body: JSON.stringify({ raceId: $selectedRaceId })
      }).catch((error) => {
        console.error('Error tracking session', error);
      });
    }
  }
</script>

<!-- global click handler to enable notifications -->
<!-- svelte-ignore a11y-no-static-element-interactions -->
<div on:click={initNotifications} on:keydown={initNotifications}>
  <div transition:fade class="absolute inset-0 flex flex-row">
    <Sidebar {filteredRaces} />
    <slot />
  </div>
</div>
